import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import SubscriptionPhaseEditor from "./editors/subscription-phase-editor"
import PhaseSlotEditor from "./editors/phase-slot-editor"

export const SubscriptionPhaseType = {
    id: "SubscriptionPhase",
    label: "Subscription Phase Configuration",
    labelField: "phase_type",
    groups: [
        {
            id: "basic",
            label: "Basic Configuration",
            description: "Phase type and status",
            expanded: true
        },
        {
            id: "pricing",
            label: "Pricing",
            description: "Price and currency for this phase",
            expanded: true
        },
        {
            id: "duration",
            label: "Duration & Billing",
            description: "Billing interval and duration",
            expanded: true
        },
        {
            id: "advanced",
            label: "Advanced",
            description: "Stripe configuration and metadata"
        }
    ],
    fields: [
        {
            id: "enabled",
            group: "basic",
            label: "Enable Phase",
            type: "Boolean",
            description: "Enable or disable this phase",
            default: true,
            render: { variant: "full" }
        },
        {
            id: "phase_type",
            group: "basic",
            label: "Phase Type",
            type: "Text",
            required: true,
            default: "regular",
            options: ["trial", "introductory", "regular"],
            description: "Type of subscription phase",
            variant: "admin_large",
            render: {
                menuPosition: "bottom",
                enableResetButton: false
            }
        },
        {
            id: "amount",
            group: "pricing",
            label: "Price Amount",
            type: "Number",
            required: true,
            description: "Price for this phase (in cents for real currency)",
            default: 0,
            variant: "admin_large"
        },
        {
            id: "currency",
            group: "pricing",
            label: "Currency",
            type: "Text",
            required: true,
            // no default: the phase editors price a new phase in the store's
            // currency (STORE_CURRENCY, from the store config)
            description: "Currency code (one of the store's currencies)",
            localization: true,
            variant: "admin_large"
        },
        {
            id: "iterations",
            group: "duration",
            label: "Number of Billing Cycles",
            type: "Number",
            description: "How many billing cycles this phase lasts (leave empty for ongoing)",
            variant: "admin_large"
        },
        {
            id: "interval",
            group: "duration",
            label: "Billing Interval",
            type: "Text",
            required: true,
            default: "month",
            options: ["day", "week", "month", "year"],
            description: "Billing frequency",
            variant: "admin_large",
            render: {
                menuPosition: "bottom",
                enableResetButton: false
            }
        },
        {
            id: "interval_count",
            group: "duration",
            label: "Interval Count",
            type: "Number",
            required: true,
            default: 1,
            description: "Billing every X intervals (e.g., 3 for 'every 3 months')",
            variant: "admin_large"
        },
        {
            id: "requires_payment_method",
            group: "advanced",
            label: "Requires Payment Method",
            type: "Boolean",
            description: "Require payment method before starting this phase",
            default: true,
            render: { variant: "full" }
        },
        {
            id: "stripe_price_id",
            group: "advanced",
            label: "Stripe Price ID",
            type: "Text",
            description: "Stripe Price ID (optional, auto-generated if empty)",
            variant: "admin_large"
        },
        {
            id: "metadata",
            group: "advanced",
            label: "Metadata",
            type: "Object",
            description: "Additional metadata for this phase",
            render: { variant: "full" }
        }
    ]
};

// Register the subscription phase editors
addFieldEditor("SubscriptionPhaseEditor", SubscriptionPhaseEditor);
addFieldEditor("PhaseSlotEditor", PhaseSlotEditor);

// Note: SubscriptionPhase is an embedded type used within PriceModel
// So it doesn't need RegisterInDBResolver = true
